import {Form, Select} from 'antd';
import {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {isArray} from 'lodash';
import {RQCommonListData} from '@app/reactQuery/apis';
import {selectAuth} from '@app/redux/selectors';
import {SystemSelectNames} from '../SystemSelectEntityEnum';
import {SortOptions} from '@app/components/common/Filters/SortOptions';
import PropTypes from 'prop-types';

const SystemMultiLevelDependentObjectAttribute = ({auth, attributeMetadata, formValues, updateDynamicFieldValue}) => {
  const form = Form.useFormInstance();
  const [searchValue, setSearchValue] = useState('');

  const parentIds = attributeMetadata?.input_parent_ids || [];

  const parentValues = parentIds.map(id => {
    const v = form.getFieldValue(id);
    if (v && typeof v === 'object') {return v.id;}
    return v ?? null;
  });

  console.log(parentValues);

  const isReady = parentValues.every(v => v !== null && v !== undefined);

  const selectEnum = SystemSelectNames[attributeMetadata.select_entity];

  const updatedMisc = {};
  if (selectEnum?.misc) {
    Object.keys(selectEnum.misc).forEach(key => {
      const value = selectEnum.misc[key];
      if (typeof value === 'string' && value.startsWith('#') && value.endsWith('#')) {
        const parentKey = value.replaceAll('#', '');
        const index = parentIds.indexOf(parentKey);
        if (index >= 0) {
          //const parentObj = parentValues[index];
          updatedMisc[key] = parentValues[index];
        }
      } else {
        updatedMisc[key] = value;
      }
    });
  }

  console.log(updatedMisc);

  const {data} = RQCommonListData(
    {
      misc: updatedMisc,
      name: selectEnum?.name,
      api: selectEnum?.api,
      certificate: auth?.certificate,
      userId: auth?.principal?.id,
      locationId: updatedMisc.locationId,
      filter:
        attributeMetadata?.input_search_enable && searchValue
          ? {[attributeMetadata.input_search_field_name]: searchValue}
          : {},
    }, {
      enabled: isReady && (!attributeMetadata?.input_search_enable || searchValue.length > 2),
    },
  );

  const options =
    attributeMetadata?.input_search_enable && searchValue.length < 3
      ? []
      : isArray(data) ? data : data ? [data] : [];

  useEffect(() => {
    if (!isReady) {return;}

    const parentChanged = parentIds.some((id, index) => {
      const currentId = parentValues[index];
      const storedValue = formValues[id];
      const storedId =
          typeof storedValue === 'object' ? storedValue?.id : storedValue;

      return currentId !== storedId;
    });

    if (parentChanged) {
      form.setFieldValue(attributeMetadata.id, undefined);

      updateDynamicFieldValue?.({
        [attributeMetadata.id]: undefined,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(parentValues)]);

  return (
    <Form.Item
      name={attributeMetadata.id}
      label={attributeMetadata.label}
      rules={attributeMetadata.validation_rules}
    >
      <Select
        allowClear
        showSearch={attributeMetadata.show_search}
        placeholder={attributeMetadata.placeholder}
        disabled={!isReady || !attributeMetadata.editable}
        onSearch={value => setSearchValue(value)}
      >
        {SortOptions(options)?.map((obj, idx) => (
          <Select.Option key={idx} value={obj?.id?.id ? obj.id.id : obj?.id}>
            {obj?.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

SystemMultiLevelDependentObjectAttribute.propTypes = {
  auth: PropTypes.shape({
    certificate: PropTypes.string.isRequired,
    principal: PropTypes.any,
    user: PropTypes.any,
  }).isRequired,

  attributeMetadata: PropTypes.shape({
    id: PropTypes.string.isRequired,
    editable: PropTypes.bool,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    validation_rules: PropTypes.array,
    select_entity: PropTypes.string.isRequired,
    input_parent_ids: PropTypes.arrayOf(PropTypes.string).isRequired,
    input_search_enable: PropTypes.bool,
    input_search_field_name: PropTypes.string,
    show_search: PropTypes.bool,
  }).isRequired,
  formValues: PropTypes.object.isRequired,
  updateDynamicFieldValue: PropTypes.func,
};

const mapState = state => ({
  auth: selectAuth(state),
});

export default connect(mapState)(SystemMultiLevelDependentObjectAttribute);
